export { default } from './HeadSubHeadWrapper';
